import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController } from 'ionic-angular'
import { COUNTRIES } from '../../config/countries'
import { CITIES } from '../../config/cities'
import * as _ from 'underscore/underscore'
import { TranslateService } from '@ngx-translate/core'
import firebase from 'firebase/app'
import { Storage } from '@ionic/storage'
import 'firebase/auth'
import { InAppBrowser } from '@ionic-native/in-app-browser'
import { LoginPage } from '../login/login';

@IonicPage()
@Component({
  selector: 'page-signup',
  templateUrl: 'signup.html',
})
export class SignupPage {

  isSubmiting = false
  defaultLan
  countries = COUNTRIES
  cities = []
  email = ''
  password = ''
  repeatPassword = ''
  country
  city
  profession
  conditions

  constructor(
    public navCtrl: NavController,
    public toastCtrl: ToastController,
    public translate: TranslateService,
    public iab: InAppBrowser,
    public storage: Storage,
    public navParams: NavParams) {

      this.defaultLan = translate.getDefaultLang()
  }

  changeLanguage(lan) {
    this.translate.setDefaultLang(lan)
  }

  updateCities() {
    this.cities = _.sortBy(_.where(CITIES, {country: this.country.name}), 'name')
  }

  checkEmail() {
    return /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(this.email)
  }

  checkPassword() {
    return this.password.length >= 6
  }

  checkPasswordsMatch() {
    return this.password === this.repeatPassword
  }

  singup() {
    this.isSubmiting = true
    firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
    .then(async data => {
      const userInfo = {
        createdAt: Math.floor(Date.now() / 1000),
        email: this.email,
        country: this.country.name,
        city: this.city.name,
        profession: this.profession
      }
      await firebase.firestore()
        .collection('appUsers')
        .doc(data.user.uid)
        .set(userInfo)
  
      await this.storage.set('userInfo',JSON.stringify(userInfo))
      this.isSubmiting = false

    })
    .catch(error => {
      this.isSubmiting = false
      console.log(error.code)
      console.log(error.message)
      this.toastCtrl.create({
        message: error.message,
        duration: 3000
      }).present()
    });
  }

  login() {
    this.navCtrl.push(LoginPage,{}, {animation: 'wp-transition'})
  } 

  openConditions () {
    this.iab.create('https://overlapp.io/terms', '_system')
  }

}



// WEBPACK FOOTER //
// ./src/pages/signup/signup.ts